import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useTranslation } from '../../translation/TranslationContext';
import { usePosContext } from '../contexts/Pos.context';
import { PosFormValues, buildPosFormSchema } from '../pos.schema';

const usePosForm = () => {
  const { translate } = useTranslation();
  const { handleAnswerLater, handleAnswerOk, isSubmitting } = usePosContext();

  const form = useForm<PosFormValues>({
    resolver: zodResolver(buildPosFormSchema(translate)),
    defaultValues: { pointOfSale: null },
  });

  const handleValidSubmit = form.handleSubmit((data) => {
    handleAnswerOk(data.pointOfSale ?? undefined);
  });

  return {
    control: form.control,
    isSubmitting,
    handleValidSubmit,
    handleAnswerLater,
  };
};

export default usePosForm;
